import { defer, type Deferred } from './async';

/**
 * A basic lock that does not support reentrancy.
 */
export class Lock {

  private locked = false;
  private pending: Deferred<void>[] = [];


  async waitForLock() {
    if (this.locked) {
      const ready = defer<void>();
      this.pending.push(ready.deferred);
      await ready.promise;
    }

    this.locked = true;
  }

  releaseLock() {
    this.locked = false;
    const d = this.pending.splice(0, 1);
    if (d.length > 0) {
      d[0]?.resolve();
    }
  }

}
